import React, { useState } from 'react';

import { InfiniteScroll } from "../../components"
import { PageListItem, PageListItem2 } from "./index.jsx"

const PageList = ({
    type,
    sort = { field: 'created_at', direction: 'desc' },
    exclude,
    itemComponent = 1,
    selectedId,
    onSelect,
    limit = 3
}) => {
    const fetchParams = {
        exclude,
        type,
        sort
    }

    const ListItem = itemComponent === 1 ? PageListItem : PageListItem2

    return (
        <InfiniteScroll
            fetchUrl='/api/pages/search'
            fetchParams={fetchParams}
            emptyMessage="No products found."
            fetchLimit={limit || 8}
        >
            {({ items, isLoading }) => (
                <div className="pages row">
                    {items.length > 0 && items.map((page) => (
                        <div className="col-md-4 col-12">
                            <ListItem
                                key={page.id}
                                selectedId={selectedId}
                                onSelect={onSelect}
                                page={page}
                            />
                        </div>
                    ))}

                    { !isLoading && items.length === 0 && (
                        <div className="no-results">
                            <p>No pages found.</p>
                        </div>
                    )}
                </div>
            )}
        </InfiniteScroll>
    )
}

export default PageList
